import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from 'antd';
import { SLA_PAGE_SIZE } from 'utils/hooks/rpmOverviewDashboard/useSlaList';
import RpmOverviewTable from 'components/molecules/rpm-overview-table';

import s from './styles.module.scss';

import type { ReactNode } from 'react';
import type { ISlaListResponse } from 'utils/hooks/rpmOverviewDashboard/useSlaList';

const { Text } = Typography;

interface IRpmOverviewSlaSectionProps {
  slaData: ISlaListResponse | undefined;
  slaInitialLoading?: boolean;
  slaFetching?: boolean;
  slaError: boolean;
  initialSkeletonClassName?: string;
  startTime?: string;
  endTime?: string;
  emptyText?: ReactNode;
}

const RpmOverviewSlaSection: React.FC<IRpmOverviewSlaSectionProps> = ({
  slaData,
  slaInitialLoading,
  slaFetching,
  slaError,
  initialSkeletonClassName,
  startTime,
  endTime,
  emptyText,
}) => {
  const { t } = useTranslation();

  const hasContent =
    !slaError &&
    (slaInitialLoading || (slaData?.patients?.length ?? 0) > 0 || !!emptyText);

  if (!hasContent) return null;

  return (
    <div className={s['section-wrapper']}>
      {!slaInitialLoading && (
        <div
          data-cy="section-header-urgent"
          data-testid="section-header-urgent"
        >
          <Text className={s['section-label']}>
            {t('labels.pods.section.urgent')}
          </Text>
        </div>
      )}
      <RpmOverviewTable
        patients={slaData?.patients ?? []}
        isInitialLoading={slaInitialLoading}
        isUrgentSection
        loading={slaFetching ?? false}
        page={1}
        setPage={() => {}}
        pageSize={SLA_PAGE_SIZE}
        wrapperId="sla-section"
        initialSkeletonClassName={initialSkeletonClassName}
        startTime={startTime}
        endTime={endTime}
        emptyText={emptyText}
      />
    </div>
  );
};

export default RpmOverviewSlaSection;
